import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { deleteAndSwapVersion } from '../../services/delete/index.tsx';
import { DELETE_VERSION, deletionSuccess, deletionFailure } from '../../state/actions.tsx';
import { getFields, getVersionId } from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';

const LOG_LOCATION = 'project-directories.versions.delete-version.ops.delete';

export const epic = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action$: ActionsObservable<any>,
	store: MiddlewareAPI<State>, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Observable<any> =>
	action$.ofType(DELETE_VERSION).mergeMap(() =>
		Observable.fromPromise(
			deleteAndSwapVersion(getVersionId(store.getState()), getFields(store.getState())),
		)
			.map(deletionSuccess)
			.catch((error) => {
				log.safeErrorWithoutCustomerData(LOG_LOCATION, error.message, error);
				return Observable.of(deletionFailure(error));
			}),
	);
